import styles from './menuContextList.module.scss';
import clsx from 'clsx';

import {RouterLink} from '@/components/channel/common/RouterLink';
import {
  ACTIVE_MENU_GROUP,
  MENU_LINK,
  MenuItem,
} from '@/components/channel/pc/layout/LeftMenu/Setting/MenuContextList/menuLink';
import {useLocation} from 'react-router-dom';

interface MenuContextListProps {
  streamerId: string;
  menuType: string;
  isManager: boolean;
}

const MenuContextList = ({
  streamerId,
  menuType,
  isManager,
}: MenuContextListProps) => {
  const location = useLocation();

  const onExternalLink = (linkUrl: string) => {
    window.open(linkUrl);
  };

  const onInternalLink = (linkUrl: string) => {
    window.open(linkUrl, '_self');
  };

  const matchPathWithParams = (template: string, actual: string) => {
    const regex = new RegExp('^' + template.replace(/:[^/]+/g, '[^/]+') + '$');
    return regex.test(actual);
  };

  const findActiveGroupKey = () => {
    const currentPath = location.pathname;

    for (const group of ACTIVE_MENU_GROUP) {
      const [key, routes] = Object.entries(group)[0]; // 하나의 key:value 쌍

      if (
        routes.some((pathTemplate) =>
          matchPathWithParams(pathTemplate, currentPath),
        )
      ) {
        return key;
      }
    }
    return null;
  };

  const activeMenu = findActiveGroupKey();

  return (
    <div className={clsx(styles.menuContextListWrapper)}>
      {MENU_LINK[menuType].map((menu: MenuItem, index) => {
        // 메니저일 경우 - 진입 가능한 메뉴만 노출
        if (isManager && !menu.managerEnter) {
          return null;
        }

        return (
          <div
            key={`${menuType}_menu_item_key_${index}`}
            className={clsx(
              styles.menuContextItem,
              activeMenu === menu.activeKey && styles.active,
            )}>
            {menu.type === 'route' && (
              <RouterLink
                name={menu.link}
                params={{streamerId: streamerId}}
                className={clsx(
                  styles.menuContextItemLabel,
                  activeMenu === menu.activeKey && styles.active,
                )}>
                {menu.name}
              </RouterLink>
            )}
            {menu.type === 'external' && (
              <span
                onClick={() => onExternalLink(menu.link)}
                className={styles.externalLabel}>
                {menu.name}
              </span>
            )}
            {menu.type === 'internal' && (
              <span
                onClick={() => onInternalLink(menu.link)}
                className={styles.externalLabel}>
                {menu.name}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MenuContextList;
